import { render, staticRenderFns } from "./diapositiva-4.vue?vue&type=template&id=765b6822&scoped=true&"
import script from "./diapositiva-4.vue?vue&type=script&lang=js&"
export * from "./diapositiva-4.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-4.vue?vue&type=style&index=0&id=765b6822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b6822",
  null
  
)

export default component.exports